import(/* webpackMode: "eager" */ "/codebuild/output/src1040292964/src/website/app/[locale]/error.tsx");
